import {
    CheckboxSize,
    ExCheckbox,
    ExInput,
    ExTextarea,
    SearchFlavor,
    SearchSize,
} from '@boomi/exosphere';
import HelpText from '../../common/HelpText';
import type { TriggerFieldInputProps } from '../../types/types';
import { getStringValue } from '../../utils/utils';

type ExoInputMode = 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';

const ExoField = ({
    option,
    value,
    onChange,
    type,
    showValidation = false,
    validationMessage = null,
}: TriggerFieldInputProps) => {
    const getModeFromType = (type: string | undefined): ExoInputMode => {
        switch (type) {
            case 'number':
                return 'numeric';
            case 'tel':
                return 'tel';
            case 'email':
                return 'email';
            case 'url':
                return 'url';
            case 'decimal':
                return 'decimal';
            case 'search':
                return 'search';
            case 'text':
                return 'text';
            default:
                return 'none';
        }
    };

    if (option.type === 'Boolean') {
        return (
            <ExCheckbox
                data-testid={option.id}
                className="exo-checkbox-input"
                input-id={option.id}
                size={CheckboxSize.LARGE}
                checked={Boolean(value)}
                onChange={(e) => onChange(option.id, (e.currentTarget as HTMLInputElement).checked)}
            >
                {option.label}
            </ExCheckbox>
        );
    }

    if (option.type === 'StringMultiline') {
        return (
            <>
                <ExTextarea
                    data-testid={option.id}
                    error-msg={validationMessage && validationMessage}
                    invalid={showValidation}
                    className="exo-text-input"
                    input-id={option.id}
                    value={getStringValue(value)}
                    onChange={(e) =>
                        onChange(option.id, (e.currentTarget as HTMLTextAreaElement).value)
                    }
                />
                {option.help && <HelpText content={option.help} />}
            </>
        );
    }

    return (
        <>
            <ExInput
                data-testid={option.id}
                error-msg={validationMessage}
                invalid={showValidation && !!validationMessage}
                className="exo-text-input"
                input-id={option.id}
                type={type}
                no-spin-buttons
                autoComplete="off"
                inputmode={getModeFromType(type)}
                size={SearchSize.MEDIUM}
                flavor={SearchFlavor.WHITE}
                value={getStringValue(value)}
                onChange={(e) =>
                    onChange(
                        option.id,
                        option.type === 'Number'
                            ? Number.parseFloat((e.currentTarget as HTMLInputElement).value)
                            : (e.currentTarget as HTMLInputElement).value,
                    )
                }
            />
            {option.help && <HelpText content={option.help} />}
        </>
    );
};

export default ExoField;
